import postMessage from '../../vendor/message_channel';

export const postToWindow = (win: Window, msg: any, ports?: MessagePort[]) =>
  postMessage(win, msg, '*', ports);
